import type { Product, Service } from '../api/use-catalogue.js';

/**
 * What kind of lesson an hour can be booked as (032; boards B3 and B4): on a
 * Lessons hour every product the family's country sells, Assessment among them
 * (Q14); on an Assessments hour the Assessment only (Q9).
 *
 * The service's name is shown under a product only when the family's country
 * sells more than one lesson service, as before Assessments: an Assessment
 * beside them is not a reason to label every row.
 */
export interface HourProduct {
  product: Product;
  serviceId: string;
  serviceName: string;
  /** Show the service's name under the product. */
  named: boolean;
  /** An Assessment: one per athlete, ever. */
  isAssessment: boolean;
}

export function hourProducts(sold: Service[], forAssessments: boolean): HourProduct[] {
  const lessonServices = sold.filter((service) => !service.is_assessment).length;
  return sold
    .filter((service) => !forAssessments || service.is_assessment)
    .flatMap((service) =>
      service.products.map((product) => ({
        product,
        serviceId: service.service_id,
        serviceName: service.name,
        named: !service.is_assessment && lessonServices > 1,
        isAssessment: service.is_assessment,
      })),
    );
}
